
document.addEventListener("DOMContentLoaded", function () {
  const isFirstVisit = sessionStorage.getItem("firstVisit");
  const bodyhome = document.querySelectorAll('body.page-template-template-home');
  if (!isFirstVisit && bodyhome .length > 0 == true) {
    document.body.classList.add("animated");
    sessionStorage.setItem("firstVisit", "true");
  };
});


class MethodologySwitcher {
  constructor(containerSelector) {
    this.container = document.querySelector(containerSelector);
    this.numberButtons = Array.from(this.container.querySelectorAll('.methodology__number'));
    this.contentItems = Array.from(this.container.querySelectorAll('.methodology__content'));
    
    this.activeIndex = this.numberButtons.findIndex(btn => btn.classList.contains("active"));
    if (this.activeIndex === -1) {
      this.activeIndex = 0; 
      this.switchContent(this.activeIndex);
    }

    this.init();
      window.addEventListener("resize", () => {
      this.switchContent(this.activeIndex);
    });
  }

  init() {
    this.numberButtons.forEach((button, index) => {
      button.addEventListener("click", () => {
        this.activeIndex = index;
        this.switchContent(index);
      });
    });
  }

  switchContent(index) {
    this.numberButtons.forEach((btn) => {
      btn.classList.remove("active");
      btn.setAttribute("tabindex", "0");
    });
    this.contentItems.forEach((item) => {
      item.classList.remove("active");
      item.setAttribute("aria-expanded", "false");
    });

    const activeButton = this.numberButtons[index];
    const activeContent = this.contentItems[index];

    if (activeButton) {
      activeButton.classList.add("active");
      activeButton.setAttribute("tabindex", "-1");

    }
    if (activeContent) {
      activeContent.classList.add("active");
      activeContent.setAttribute("aria-expanded", "true");
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new MethodologySwitcher(".methodology");
});
